import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["popper"];
export function partitionPopperPropsFromShorthand(value) {
  if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
    var _ref = value,
      popper = _ref.popper,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);
    return [props, popper];
  }
  return [value, {}];
}
//# sourceMappingURL=partitionPopperPropsFromShorthand.js.map
